<script setup>
import { onMounted, onBeforeMount, onBeforeUnmount, ref } from 'vue';
import OT from '@opentok/client';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

const store = useStore();
const route = useRoute();

const apiKey = ref(route.query.API_KEY || '');
const sessionId = ref(route.query.SESSION_ID || '');
const token = ref(route.query.TOKEN || '');
let callerSession = null;

// Función para manejar errores
function handleError(error) {
  if (error) {
    console.error(error);
  }
}

// Función para inicializar la sesión de OpenTok
function initializeSession() {
  // Verificar si ya existe una sesión activa
  if (callerSession && callerSession.isConnected()) {
    console.log('Ya existe una sesión activa. No se inicializará otra.');
    return;
  }

  if (!apiKey.value || !sessionId.value || !token.value) {
    console.error('Faltan parámetros para inicializar la sesión');
    return;
  }

  callerSession = OT.initSession(apiKey.value, sessionId.value);

  callerSession.on('streamCreated', (event) => {
    const subscriberOptions = {
      insertMode: 'append',
      width: '100%',
      height: '100%',
    };
    callerSession.subscribe(event.stream, 'subscriber', subscriberOptions, handleError);
  });

  callerSession.on('sessionDisconnected', (event) => {
    console.log('You were disconnected from the session.', event.reason);
    callerSession = null; // Restablecer la sesión a null cuando se desconecte
  });

  const publisherOptions = {
    insertMode: 'append',
    width: '100%',
    height: '100%',
  };
  const publisher = OT.initPublisher('publisher', publisherOptions, handleError);

  callerSession.connect(token.value, (error) => {
    if (error) {
      handleError(error);
    } else {
      callerSession.publish(publisher, handleError);
    }
  });
}

// Función para cortar la llamada y cerrar la pestaña
function endCall(callerId) {
  if (callerSession && callerSession.isConnected()) {
    callerSession.disconnect();
    console.log('Call ended');
  }
  deleteCaller(callerId);
  window.close(); // Cierra la pestaña actual
}

// Función para eliminar el identificador del llamador
function deleteCaller(callerId) {
  console.log(`Caller ${callerId} has been removed.`);
  // Lógica adicional para eliminar el callerId, si es necesario
}

onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
});

onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
});

onMounted(() => {
  initializeSession();
});
</script>

<template>
  <div>
    <div id="videos">
      <div id="subscriber">
        <button @click="endCall('callerId123')" class="end-call-button">
          Cortar Llamada
        </button>
        <div id="publisher"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
#videos {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
}

#subscriber {
  position: relative;
  width: 100%;
  height: 100dvh;
  background-color: #ddd;
}

#publisher {
  position: absolute;
  width: 25%;
  height: 25%;
  bottom: 10px;
  right: 10px;
  background-color: #ccc;
  border: 2px solid #fff;
  border-radius: 4px;
  z-index: 1;
}

.end-call-button {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 10px 20px;
  background-color: red;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  z-index: 10;
}

.end-call-button:hover {
  background-color: darkred;
}
</style>
